import axios from 'axios'
import qs from 'qs'
import FileSaver from 'file-saver'
import fn from '../../utils/functions'

function initSession () {
  const session = {
    // Nueva Albaran
    createDeliveryNote: {},
    optionsBuyersCreateDeliveryNote: [],
    optionsNewDeliveryNoteBuyer: [],
    optionsNewDeliveryNoteSeller: [],
    optionsDeliveryNoteLineTax: []
  }
  return session
}
function initLocal () {
  const local = {
    // Columnas Tabla Lineas de albaran
    isShowDescripcionLineaAlbaran: true,
    isShowCodigoArticuloLineaAlbaran: true,
    isShowCodigoArticuloSellerLineaAlbaran: false,
    isShowCodigoArticuloBuyerLineaAlbaran: false,
    isShowCodigoLugarEntregaLineaAlbaran: false,
    isShowCantidadLineaAlbaran: true,
    isShowUnidadMedidaLineaAlbaran: true,
    isShowCantidadEmbalajeLineaAlbaran: false,
    isShowUnidadMedidaEmbalajeLineaAlbaran: false,
    isShowGtin14LineaAlbaran: false,
    isShowLoteLineaAlbaran: true,
    isShowCaducidadLineaAlbaran: true,
    isShowSerieLineaAlbaran: true
  }
  return local
}
function setByUserLocalCreateAlbaran () {
  const local = {
    // Columnas Tabla Lineas de albaran
    isShowDescripcionLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowDescripcionLineaAlbaran,
    isShowCodigoArticuloLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowCodigoArticuloLineaAlbaran,
    isShowCodigoArticuloSellerLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowCodigoArticuloSellerLineaAlbaran,
    isShowCodigoArticuloBuyerLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowCodigoArticuloBuyerLineaAlbaran,
    isShowCodigoLugarEntregaLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowCodigoLugarEntregaLineaAlbaran,
    isShowCantidadLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowCantidadLineaAlbaran,
    isShowUnidadMedidaLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowUnidadMedidaLineaAlbaran,
    isShowCantidadEmbalajeLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowCantidadEmbalajeLineaAlbaran,
    isShowUnidadMedidaEmbalajeLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowUnidadMedidaEmbalajeLineaAlbaran,
    isShowLoteLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowLoteLineaAlbaran,
    isShowCaducidadLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowCaducidadLineaAlbaran,
    isShowSerieLineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowSerieLineaAlbaran,
    isShowGtin14LineaAlbaran: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).creacionAlbaran.isShowGtin14LineaAlbaran
  }
  return local
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {
    // Columnas Tabla Lineas de albaran
    isShowDescripcionLineaAlbaran: true,
    isShowCodigoArticuloLineaAlbaran: true,
    isShowCodigoArticuloSellerLineaAlbaran: false,
    isShowCodigoArticuloBuyerLineaAlbaran: false,
    isShowCodigoLugarEntregaLineaAlbaran: false,
    isShowCantidadLineaAlbaran: true,
    isShowUnidadMedidaLineaAlbaran: true,
    isShowCantidadEmbalajeLineaAlbaran: false,
    isShowUnidadMedidaEmbalajeLineaAlbaran: false,
    isShowLoteLineaAlbaran: true,
    isShowCaducidadLineaAlbaran: true,
    isShowSerieLineaAlbaran: true,
    isShowGtin14LineaAlbaran: false

  },
  session: initSession()
}

// getters
const getters = {
  // Columnas Tabla Líneas de albaran
  isShowDescripcionLineaAlbaran: state => {
    return state.local.isShowDescripcionLineaAlbaran
  },
  isShowCodigoArticuloLineaAlbaran: state => {
    return state.local.isShowCodigoArticuloLineaAlbaran
  },
  isShowCodigoArticuloSellerLineaAlbaran: state => {
    return state.local.isShowCodigoArticuloSellerLineaAlbaran
  },
  isShowCodigoArticuloBuyerLineaAlbaran: state => {
    return state.local.isShowCodigoArticuloBuyerLineaAlbaran
  },
  isShowCodigoLugarEntregaLineaAlbaran: state => {
    return state.local.isShowCodigoLugarEntregaLineaAlbaran
  },
  isShowCantidadLineaAlbaran: state => {
    return state.local.isShowCantidadLineaAlbaran
  },
  isShowUnidadMedidaLineaAlbaran: state => {
    return state.local.isShowUnidadMedidaLineaAlbaran
  },
  isShowCantidadEmbalajeLineaAlbaran: state => {
    return state.local.isShowCantidadEmbalajeLineaAlbaran
  },
  isShowUnidadMedidaEmbalajeLineaAlbaran: state => {
    return state.local.isShowUnidadMedidaEmbalajeLineaAlbaran
  },
  isShowLoteLineaAlbaran: state => {
    return state.local.isShowLoteLineaAlbaran
  },
  isShowCaducidadLineaAlbaran: state => {
    return state.local.isShowCaducidadLineaAlbaran
  },
  isShowSerieLineaAlbaran: state => {
    return state.local.isShowSerieLineaAlbaran
  },
  isShowGtin14LineaAlbaran: state => {
    return state.local.isShowGtin14LineaAlbaran
  },

  // Nueva Albaran
  createDeliveryNote: state => {
    return state.session.createDeliveryNote
  },
  // Combos  
  optionsBuyersCreateDeliveryNote: state => {
    return state.session.optionsBuyersCreateDeliveryNote
  },
  // FLAG
  optionsNewDeliveryNoteBuyer: state => {
    return state.session.optionsNewDeliveryNoteBuyer
  },
  optionsNewDeliveryNoteSeller: state => {
    return state.session.optionsNewDeliveryNoteSeller
  },
  optionsDeliveryNoteLineTax: state => {
    return state.session.optionsDeliveryNoteLineTax
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNameCreateAlbaran ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalCreateAlbaran()
    }
  },
  isNewVersionCreacionAlbaranLocalState ({ state }, localStorage) {
    return fn.isNewVersion(state, localStorage.creacionAlbaran)
  },
  // Método para obtener la cabecera de una albaran
  async getDeliveryNoteHeader ({
    commit, rootState
  }, idDeliveryNote) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNote/header/' + idDeliveryNote,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Método para obtener la cabecera de una albaran a través de un pedido
  async getDeliveryNoteHeaderByOrder ({
    commit, rootState
  }, idOrder) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNote/order/' + idOrder,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          orderId: idOrder
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  }, 

  /**
   * Servicio para enviar el borrador de albaran
   */
   async sendDeliveryNote ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/deliveryNote/send',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Método para crear o actualizar una albaran
  async saveDeliveryNote ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/deliveryNote/create',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: data.query
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  }, 
  /**
   * Servicio para obtener todas las líneas de albaran
   * dado el identificador de una albaran.
   */
  async getAllDeliveryNoteLines ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNoteline/all',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

    // Obtenemos matricula para la empresa emisora del albaran
    async getDeliveryNoteCodeSSCC ({ commit, rootState }, params) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/deliveryNote/' + params.deliveryNoteId + '/codeSSCC',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        })
  
        console.log('RESPONSE getDeliveryNoteCodeSSCC:: ', response)
  
        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data.ssccCode
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },  

  /**
   * Servicio para actualizar o crear una línea de albaran
   */
  async updateDeliveryNoteLine ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/deliveryNoteline/update',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: data.id,
          idDeliveryNote: data.idDeliveryNote,
          description: data.description,
          articleCode: data.articleCode,
          quantityShipped: data.quantityShipped,
          unitOfMeasureId: data.unitOfMeasureId,
          batch: data.batch,
          serialNumber: data.serialNumber,
          expirationDate: data.expirationDate,
          deliveryNotePackageId: data.deliveryNotePackageId
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },
   /**
   * Servicio para actualizar o crear una línea de albaran
   */
    async updateDeliveryNoteLineQuantity ({
      commit, rootState
    }, data) {
      try {
        const response = await axios({
          method: 'POST',
          url: '/deliveryNoteline/updateQuantity',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          data: {
            id: data.id,
            quantity: data.quantity,
          }
        })
  
        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error)
        throw error.response
      }
    },

  /**
   * Servicio para actualizar el número de línea de las líneas finales de un albarán
   */
  async updateDeliveryNoteLineNumber ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/deliveryNoteline/' + data.deliveryNoteId + '/updateLineNumber',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },

  /**
   * Servicio de actualización del embalaje asociado a una lista de líneas de albarán
   */
  async updateDeliveryNoteLinePackage ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/deliveryNoteline/updatePackage',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },

  /**
   * Servicio para actualizar o crear el embalaje de un albarán
   */
  async updateDeliveryNotePackage ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/deliveryNoteline/package/update',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: data
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },

  /**
   * Servicio para obtener una determinada línea de albaran
   */
  async getDeliveryNoteLine ({
    commit, rootState
  }, deliveryNoteLineId) {
    if(deliveryNoteLineId){
      try {
        const response = await axios({
          method: 'GET',
          url: '/deliveryNoteline/' + deliveryNoteLineId,
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL
        })

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    } else {
      console.log('ERROR getDeliveryNoteLine:: No deliveryNoteLineId')  
    }
  },

  /**
   * Servicio para eliminar una determinada línea de albaran
   */
  async deleteDeliveryNoteLine ({
    commit, rootState
  }, deliveryNoteLineId) {
    if(deliveryNoteLineId){
      try {
        const response = await axios({
          method: 'DELETE',
          url: '/deliveryNoteline/' + deliveryNoteLineId,
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL
        })

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    } else {
      console.log('ERROR deleteDeliveryNoteLine:: No deliveryNoteLineId')  
    }
  },

  /**
   * Servicio para eliminar uno o más embalaje de albaran
   */
  async deleteMultipleDeliveryNotePackage ({
    commit, rootState
  }, data) {
    if(data.deliveryNotePackageIds){
      try {
        const response = await axios({
          method: 'DELETE',
          url: '/deliveryNoteline/package',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          params: {
            deliveryId: data.deliveryId,
            deliveryPackageIds: data.deliveryNotePackageIds
          },
          paramsSerializer: params => {
            return qs.stringify(params, {
              indices: false
            })
          }
        })

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    } else {
      console.log('ERROR deleteDeliveryNotePackage:: No deliveryNotePackageId')  
    }
  },
  /**
 * Servicio para obtener los tipos de embalaje que existen
 */
  async getOptionsDeliveryNotePackageTypes ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNoteline/packagetypes',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  }, 

  /**
   * Servicio para obtener todas las líneas de embalaje de albaran
   * dado el identificador de una albaran.
   */
  async getAllDeliveryNotePackageStructure ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNoteline/package/all',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data,
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener todas las líneas asociadas al embalaje de un albaran
   */
  async getDeliveryNoteLinesByPackage ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/deliveryNoteline/package/' + data.deliveryPackageId + '/lines',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,        
        params: {
          deliveryNoteId: data.deliveryId,
          deliveryPointCentreId: data.deliveryPointCentreId
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            indices: false
          })
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Columnas Tabla Lineas de albaran
  isShowDescripcionLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_DESCRIPCION_LINEA_ALBARAN', payload)
  },
  isShowCodigoArticuloLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CODIGO_ARTICULO_LINEA_ALBARAN', payload)
  },
  isShowCodigoArticuloSellerLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CODIGO_ARTICULO_SELLER_LINEA_ALBARAN', payload)
  },
  isShowCodigoArticuloBuyerLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CODIGO_ARTICULO_BUYER_LINEA_ALBARAN', payload)
  },
  isShowCodigoLugarEntregaLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CODIGO_LUGAR_ENTREGA_LINEA_ALBARAN', payload)
  },
  isShowCantidadLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CANTIDAD_LINEA_ALBARAN', payload)
  },
  isShowUnidadMedidaLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_UNIDAD_MEDIDA_LINEA_ALBARAN', payload)
  },
  isShowCantidadEmbalajeLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CANTIDAD_EMBALAJE_LINEA_ALBARAN', payload)
  },
  isShowUnidadMedidaEmbalajeLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_UNIDAD_MEDIDA_EMBALAJE_LINEA_ALBARAN', payload)
  },
  isShowLoteLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_LOTE_LINEA_ALBARAN', payload)
  },
  isShowCaducidadLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_CADUCIDAD_LINEA_ALBARAN', payload)
  },
  isShowSerieLineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_SERIE_LINEA_ALBARAN', payload)
  },
  isShowGtin14LineaAlbaranAction: ({
    commit
  }, payload) => {
    commit('IS_SHOW_GTIN14_LINEA_ALBARAN', payload)
  },
    
  // Nueva Albaran
  createDeliveryNoteState: ({
    commit
  }, payload) => {
    commit('CREATE_DELIVERY_NOTE_STATE', payload)
  },  
  optionsBuyersCreateDeliveryNoteState: ({
    commit
  }, payload) => {
    commit('OPTIONS_BUYER_CI_STATE', payload)
  },
  optionsNewDeliveryNoteBuyerState: ({
    commit
  }, payload) => {
    commit('OPTIONS_NEW_DELIVERY_NOTE_BUYER_STATE', payload)
  },
  optionsNewDeliveryNoteSellerState: ({
    commit
  }, payload) => {
    commit('OPTIONS_NEW_DELIVERY_NOTE_SELLER_STATE', payload)
  },
  optionsDeliveryNoteLineTaxState: ({
    commit
  }, payload) => {
    commit('OPTIONS_DELIVERY_NOTE_LINE_TAX_STATE')
  }
}

// mutations
const mutations = {
  resetSessionCreacionAlbaran (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Columnas Tabla Lineas de albaran
  'IS_SHOW_DESCRIPCION_LINEA_ALBARAN' (state, payload) {
    state.local.isShowDescripcionLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowDescripcionLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CODIGO_ARTICULO_LINEA_ALBARAN' (state, payload) {
    state.local.isShowCodigoArticuloLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowCodigoArticuloLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CODIGO_ARTICULO_SELLER_LINEA_ALBARAN' (state, payload) {
    state.local.isShowCodigoArticuloSellerLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowCodigoArticuloSellerLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CODIGO_ARTICULO_BUYER_LINEA_ALBARAN' (state, payload) {
    state.local.isShowCodigoArticuloBuyerLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowCodigoArticuloBuyerLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CODIGO_LUGAR_ENTREGA_LINEA_ALBARAN'(state, payload) {
    state.local.isShowCodigoLugarEntregaLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowCodigoLugarEntregaLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CANTIDAD_LINEA_ALBARAN' (state, payload) {
    state.local.isShowCantidadLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowCantidadLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_UNIDAD_MEDIDA_LINEA_ALBARAN' (state, payload) {
    state.local.isShowUnidadMedidaLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowUnidadMedidaLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CANTIDAD_EMBALAJE_LINEA_ALBARAN' (state, payload) {
    state.local.isShowCantidadEmbalajeLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowCantidadEmbalajeLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_UNIDAD_MEDIDA_EMBALAJE_LINEA_ALBARAN' (state, payload) {
    state.local.isShowUnidadMedidaEmbalajeLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowUnidadMedidaEmbalajeLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_LOTE_LINEA_ALBARAN' (state, payload) {
    state.local.isShowLoteLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowLoteLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CADUCIDAD_LINEA_ALBARAN' (state, payload) {
    state.local.isShowCaducidadLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowCaducidadLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SERIE_LINEA_ALBARAN' (state, payload) {
    state.local.isShowSerieLineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowSerieLineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_GTIN14_LINEA_ALBARAN' (state, payload) {
    state.local.isShowGtin14LineaAlbaran = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.creacionAlbaran.isShowGtin14LineaAlbaran = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  
  // Nueva Albaran
  'CREATE_DELIVERY_NOTE_STATE' (state, payload) {
    state.session.createDeliveryNote = payload
  },
  'OPTIONS_BUYER_CI_STATE' (state, payload) {
    state.session.optionsBuyersCreateDeliveryNote = payload
  },
  'OPTIONS_NEW_DELIVERY_NOTE_BUYER_STATE' (state, payload) {
    state.session.optionsNewDeliveryNoteBuyer = payload
  },
  'OPTIONS_NEW_DELIVERY_NOTE_SELLER_STATE' (state, payload) {
    state.session.optionsNewDeliveryNoteSeller = payload
  },
  'OPTIONS_DELIVERY_NOTE_LINE_TAX_STATE' (state, payload) {
    state.session.optionsDeliveryNoteLineTax = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
